import React from 'react'

import formatDate from 'helpers/dateTimeFormatter'

export const allMessages = (t, isEmpty = true) => [
	{
		Header: t('message_section.fields.created'),
		accessor: 'createdAt',
		Cell: ({ value }) => formatDate(value, 'DD.MM.YYYY HH:mm'),
		width: isEmpty ? 140 : 250
	},
	{
		Header: t('message_section.fields.subject'),
		accessor: 'subject',
		width: isEmpty ? 140 : 660
	},
	{
		Header: t('message_section.fields.sender'),
		accessor: 'sender',
		width: isEmpty ? 'auto' : 200,
		sortable: false
	}
]

export const userList = t => [
	{
		Header: <span className='sort-icons'>{t('common.fields.code')}</span>,
		accessor: 'code',
		width: 90
	}, {
		Header: ({ data }) => <span>{`${t('message_section.fields.user_name')} (${data.length})`}</span>,
		accessor: 'name',
		sortable: false
	}
]

// Clarify all data in table
export const clientMessages = t => [
	{
		Header: t('message_section.fields.type'),
		accessor: 'isForShop',
		Cell: ({ value }) => value ? t('message_section.strings.branch') : t('message_section.strings.user')
	}, {
		Header: t('message_section.fields.info'),
		accessor: 'name'
	}, {
		Header: t('message_section.fields.answer'),
		accessor: 'answer.code',
		Cell: ({ value }) => {
			switch (value) {
				case 'ACCEPTED':
					return t('message_section.strings.accepted')
				case 'DECLINED':
					return t('message_section.strings.declined')
				case 'READ':
					return t('message_section.strings.mark_as_read')
				default:
					return ''
			}
		}
	}, {
		Header: t('message_section.fields.read_by'),
		accessor: 'answer.user.name',
		Cell: ({ value }) => !value ? '' : value
	}, {
		Header: t('message_section.fields.created'),
		accessor: 'createdAt',
		Cell: ({ value }) => !value ? '' : formatDate(value, 'DD.MM.YYYY HH:mm')
	}, {
		Header: t('message_section.fields.confirmed_on'),
		accessor: 'answer.readAt',
		Cell: ({ value }) => !value ? '' : formatDate(value, 'DD.MM.YYYY HH:mm:ss')
	}, {
		Header: t('message_section.fields.shop'),
		accessor: 'answer.shop.name',
		Cell: ({ value }) => !value ? '' : value
	}
]

